import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface PartnerFileValidationRejectedProps extends BaseTemplateProps {
  filename: string
  rejectedRowCount: number
  validationQueries: string
}

export const PartnerFileValidationRejectedRows: TemplateDefinition<PartnerFileValidationRejectedProps> =
  {
    renderParams: (props: PartnerFileValidationRejectedProps) => ({
      messageKey: 'notificationsDomain.templates.partnerFileValidationRejectedRows',
      values: {
        filename: props.filename,
        rejectedRowCount: props.rejectedRowCount,
        validationQueries: props.validationQueries,
      },
    }),
  }
